import { useLang } from "./useLang";
import { useCountry } from "./useCountry";

export function useLangCountry(): string {
  const lang = useLang();
  const country = useCountry();
  return `/${lang}/${country}`;
}
